import { Typography } from "@mui/material";
import { FaCheck, FaStar } from "react-icons/fa6";
import { IoClose, IoSend } from "react-icons/io5";
import { Link } from "react-router-dom";

import useScreenSize from "../../../hooks/useScreenSize";
import { useWhiteScreen } from "../../../hooks/useWhiteScreen";
import { Container } from "../../common/Container/Container";
import androidImage from "../../imagenes/android.svg";
import iosImage from "../../imagenes/ios.svg";
import webImage from "../../imagenes/web.svg";
import { Heading } from "../../ui/Typography/Typography";

import "./flight_recorder.scss";

export function FlightRecorder() {
	useWhiteScreen();
	const { width } = useScreenSize();
	// const isPhone = width <= 576;
	const isMobile = width <= 768;

	const demoUrl = `${process.env.REACT_APP_CLOULDFRONT_URL}/flyorka-docs/demo_app_july_2025.mp4`;
	const whyFlyOrkaUrl = `${process.env.REACT_APP_CLOULDFRONT_URL}/flyorka-docs/why_flyorka.mp4`;

	return (
		<Container
			className="flight-recorder-container"
			headerWithTransparentBackground>
			<div
				style={{
					width: "100%",
					padding: "16px 32px",
					backgroundColor: "black",
				}}>
				<Typography className="normal-text yellow-text bold italic we-log-memories-text">
					{
						"We log memories—not just flight hours            We log memories—not just flight hours            We log memories—not just flight hours            We log memories—not just flight hours            We log memories—not just flight hours            We log memories—not just flight hours            We log memories—not just flight hours            We log memories—not just flight hours            We log memories—not just flight hours            We log memories—not just flight hours            "
					}
				</Typography>
			</div>
			{!isMobile && (
				<div className="for-instructor-image-container">
					<img
						src={require("../../imagenes/landing_page_background_desktop.png")}
						className="image"
					/>
					<div className="caption-container">
						<Heading as="h1">
							Training pays off when
							<br />
							you take command
						</Heading>
						<Typography
							className="description"
							marginTop="8px"
							textAlign="center">
							Download the Fly ORKA app to train smarter, track progress, cheer
							each other on, and pick pilots to fly with.
						</Typography>
						<div className="app-button-container">
							<Link
								target="_blank"
								to={process.env.REACT_APP_ANDROID_APP_LINK ?? ""}>
								<img
									className="download-app-image"
									src={require("../../imagenes/download_google.png")}
								/>
							</Link>
							<Link
								target="_blank"
								to={process.env.REACT_APP_IOS_APP_LINK ?? ""}>
								<img
									className="download-app-image"
									src={require("../../imagenes/download_apple.png")}
								/>
							</Link>
						</div>
					</div>
				</div>
			)}
			{isMobile && (
				<div className="for-instructor-image-container">
					<img
						src={require("../../imagenes/landing_page_background_mobile.png")}
						className="image"
					/>
					<div className="caption-container">
						<Typography className="title bold" textAlign="center">
							Training pays off when
							<br />
							you take command
						</Typography>
						<Typography
							className="description"
							marginTop="8px"
							textAlign="center">
							Download the Fly ORKA app to train smarter, track progress, cheer
							each other on, and pick pilots to fly with.
						</Typography>
						<div className="app-button-container">
							<Link
								target="_blank"
								to={process.env.REACT_APP_ANDROID_APP_LINK ?? ""}>
								<img
									className="download-app-image"
									src={require("../../imagenes/download_google.png")}
								/>
							</Link>
							<Link
								target="_blank"
								to={process.env.REACT_APP_IOS_APP_LINK ?? ""}>
								<img
									className="download-app-image"
									src={require("../../imagenes/download_apple.png")}
								/>
							</Link>
						</div>
					</div>
				</div>
			)}
			<div className="introduction-text-container">
				<Typography className="title-text bold">
					Make Fly ORKA work for you
				</Typography>
				<Typography className="normal-text">
					Fly ORKA gives you all the pieces to participate in flying and make
					the most of your flight time.
				</Typography>
				<img
					className="banner-image"
					src={require("../../imagenes/flyorka_app_banner.jpg")}
				/>
				<Typography className="normal-text" marginTop="16px">
					Learn about parts of the app designed to help you:
				</Typography>
				<div className="mission-item-title-container">
					<div className="mission-item-bullet">
						<Typography className="big-text bold mission-item-bullet-text">
							1
						</Typography>
					</div>
					<Typography className="big-text bold">Train Smarter</Typography>
				</div>
				<div className="mission-item-explanation">
					<FaStar className="normal-icon star-icon" />
					<Typography className="normal-text mission-item-explanation-text">
						Record every flight with just your phone or watch.
					</Typography>
				</div>
				<div className="mission-item-explanation">
					<FaStar className="normal-icon star-icon" />
					<Typography className="normal-text mission-item-explanation-text">
						Relive your flights in 3D with aircraft models and flight data.
					</Typography>
				</div>
				<div className="mission-item-explanation">
					<FaStar className="normal-icon star-icon" />
					<Typography className="normal-text mission-item-explanation-text">
						Track your progress on a personal flying activity board with notes,
						photos, and flight paths.
					</Typography>
				</div>

				<div className="mission-item-title-container">
					<div className="mission-item-bullet">
						<Typography className="big-text bold mission-item-bullet-text">
							2
						</Typography>
					</div>
					<Typography className="big-text bold">Learn More</Typography>
				</div>
				<div className="mission-item-explanation">
					<FaStar className="normal-icon star-icon" />
					<Typography className="normal-text mission-item-explanation-text">
						You're not alone. Discuss flying anytime, learn about local
						information and points of interest noted by other pilots.
					</Typography>
				</div>
				<div className="mission-item-explanation">
					<FaStar className="normal-icon star-icon" />
					<Typography className="normal-text mission-item-explanation-text">
						Build your tribe with flying buddies and pilots you look up to: find
						out what's working for them, what bumps they're encountering, where
						they're flying on cross-countries, and how they're progressing.
					</Typography>
				</div>
				<div className="mission-item-explanation">
					<FaStar className="normal-icon star-icon" />
					<Typography className="normal-text mission-item-explanation-text">
						Expand your horizon and fly safer with a community flying board
						where you can explore flights and pilot experience all around the
						world.
					</Typography>
				</div>

				<div className="mission-item-title-container">
					<div className="mission-item-bullet">
						<Typography className="big-text bold mission-item-bullet-text">
							3
						</Typography>
					</div>
					<Typography className="big-text bold">Own Your Story</Typography>
				</div>
				<div className="mission-item-explanation">
					<FaStar className="normal-icon star-icon" />
					<Typography className="normal-text mission-item-explanation-text">
						Remember your milestones, people, and aircraft.
					</Typography>
				</div>
				<div className="mission-item-explanation">
					<FaStar className="normal-icon star-icon" />
					<Typography className="normal-text mission-item-explanation-text">
						Showcase your experience, achievements, and journey on a living
						pilot profile (like LinkedIn for pilots).
					</Typography>
				</div>
				<div className="mission-item-explanation">
					<FaStar className="normal-icon star-icon" />
					<Typography className="normal-text mission-item-explanation-text">
						Share progress with mentors, instructors, or those supporting your
						training.
					</Typography>
				</div>

				<video
					key={demoUrl}
					controls
					controlsList="nodownload"
					playsInline
					className="video">
					<source src={demoUrl} type="video/mp4" />
				</video>

				<div className="platform-container">
					<img src={webImage} className="platform-icon" />
					<Link
						target="_blank"
						to={process.env.REACT_APP_ANDROID_APP_LINK ?? ""}>
						<img src={androidImage} className="platform-icon" />
					</Link>
					<Link target="_blank" to={process.env.REACT_APP_IOS_APP_LINK ?? ""}>
						<img src={iosImage} className="platform-icon" />
					</Link>
				</div>
			</div>
			<div className="introduction-text-container">
				<Typography className="title-text bold">Why Fly ORKA?</Typography>
				<Typography className="normal-text">
					Flight training is all about preparation and how you spend each hour
					of training. Pilots who rely only on flight schools and instructors
					can spend $1000s and face unnecessary delays without learning.
				</Typography>
				<Typography className="normal-text" marginTop="16px">
					Waste no time. Waste no money. Fly ORKA is built by pilots chasing
					mastery. We understand the challenges of training, how to accelerate
					progress, and the importance of feeling good.
				</Typography>
				<table className="comparison-table">
					<thead>
						<tr>
							<Typography className="normal-text bold" component="th">
								Current Approaches to Flight Training
							</Typography>
							<Typography className="normal-text bold" component="th">
								With Fly ORKA
							</Typography>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<div className="table-row">
									<IoClose className="normal-icon close-icon" />
									<Typography className="normal-text info-text">
										Paper or digital logbooks don't tell the full story
									</Typography>
								</div>
							</td>
							<td>
								<div className="table-row">
									<FaCheck className="normal-icon check-icon" />
									<Typography className="normal-text info-text">
										Interactive flying board with animated flights full of
										context
									</Typography>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div className="table-row">
									<IoClose className="normal-icon close-icon" />
									<Typography className="normal-text info-text">
										Lost Advice
									</Typography>
								</div>
							</td>
							<td>
								<div className="table-row">
									<FaCheck className="normal-icon check-icon" />
									<Typography className="normal-text info-text">
										Peer support and expert voices are attached to actual
										flights
									</Typography>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div className="table-row">
									<IoClose className="normal-icon close-icon" />
									<Typography className="normal-text info-text">
										Progress measured by pass/fail gates and generic milestones
									</Typography>
								</div>
							</td>
							<td>
								<div className="table-row">
									<FaCheck className="normal-icon check-icon" />
									<Typography className="normal-text info-text">
										Progress measured by continuous improvement and personal
										goals
									</Typography>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div className="table-row">
									<IoClose className="normal-icon close-icon" />
									<Typography className="normal-text info-text">
										Students often repeat lessons without learning
									</Typography>
								</div>
							</td>
							<td>
								<div className="table-row">
									<FaCheck className="normal-icon check-icon" />
									<Typography className="normal-text info-text">
										Students know exactly what to work on next
									</Typography>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div className="table-row">
									<IoClose className="normal-icon close-icon" />
									<Typography className="normal-text info-text">
										Training feels like checking boxes
									</Typography>
								</div>
							</td>
							<td>
								<div className="table-row">
									<FaCheck className="normal-icon check-icon" />
									<Typography className="normal-text info-text">
										Training feels like building mastery
									</Typography>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div className="table-row">
									<IoClose className="normal-icon close-icon" />
									<Typography className="normal-text info-text">
										Inconsistent student and instructor support
									</Typography>
								</div>
							</td>
							<td>
								<div className="table-row">
									<FaCheck className="normal-icon check-icon" />
									<Typography className="normal-text info-text">
										Direct personal support from a world class team
									</Typography>
								</div>
							</td>
						</tr>
					</tbody>
				</table>

				<video
					key={whyFlyOrkaUrl}
					controls
					controlsList="nodownload"
					playsInline
					className="video">
					<source src={whyFlyOrkaUrl} type="video/mp4" />
				</video>

				<Typography className="normal-text" marginTop="16px">
					Fly ORKA is about flying strong, with grit, and flying well. We landed
					on the Swedish word ORKA because it captures the energy and
					determination to do your best.
				</Typography>
			</div>

			<div className="introduction-text-container">
				<Typography className="title-text bold">Fly ORKA is for...</Typography>
				<div className="flyorka-is-for">
					<IoSend className="normal-icon send-icon" />
					<Typography className="normal-text flyorka-is-for-text">
						Student Pilots who want to save money, progress faster, and have
						fun.
					</Typography>
				</div>

				<div className="flyorka-is-for">
					<IoSend className="normal-icon send-icon" />
					<Typography className="normal-text flyorka-is-for-text">
						Career-Track Pilots who need to show progress and experience.
					</Typography>
				</div>

				<div className="flyorka-is-for">
					<IoSend className="normal-icon send-icon" />
					<Typography className="normal-text flyorka-is-for-text">
						Parents/Sponsors who want to know where the money is being spent.
					</Typography>
				</div>

				<div className="flyorka-is-for">
					<IoSend className="normal-icon send-icon" />
					<Typography className="normal-text flyorka-is-for-text">
						Everyone who cares about talent, flight safety, and pilot wellness.
					</Typography>
				</div>
			</div>

			<div className="introduction-text-container">
				<Typography className="title-text bold">
					Take command and discover how far community-powered motivation can
					take you.
				</Typography>
				<div className="app-button-container">
					<Link
						target="_blank"
						to={process.env.REACT_APP_ANDROID_APP_LINK ?? ""}>
						<img
							className="download-app-image"
							src={require("../../imagenes/download_google.png")}
						/>
					</Link>
					<Link target="_blank" to={process.env.REACT_APP_IOS_APP_LINK ?? ""}>
						<img
							className="download-app-image"
							src={require("../../imagenes/download_apple.png")}
						/>
					</Link>
				</div>
			</div>
		</Container>
	);
}
